import React from "react";

import TextHeader from "./TextHeader";
import PortletWrapper from "./PortletWrapper";

const Loading = () => (
    <PortletWrapper>
        <TextHeader heading="Loading..." />
    </PortletWrapper>
);

export default Loading;



// WEBPACK FOOTER //
// ./components/misc/Loading.jsx